$(function () {
  $('.js-backToTop').hide();
  $(window).on('scroll',function () {
    if ($(this).scrollTop() > 110) {
      $('.js-backToTop').fadeIn('fast');
      if($('.js-chatbot-area').length) {
        if ($('body').css('min-width') == '1060px') {
          $('.js-chatbot-area').css('bottom','54px');
        }
      }
    } else {
      $('.js-backToTop').fadeOut('fast');
      if($('.js-chatbot-area').length) {
        if ($('body').css('min-width') == '1060px') {
          $('.js-chatbot-area').css('bottom','20px');
        }
      }
    }
  });
  $(window).on('resize', function () {
    if ($('body').css('min-width') == '1060px') {
      if ($(this).scrollTop() > 100) {
        $('.js-backToTop').fadeIn('fast');
      } else {
        $('.js-backToTop').hide('fast');
      }
    } else {
      $('.js-backToTop').removeAttr('style');
      $('.js-chatbot-area').css('bottom','10px');
    }
  });
});
